<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
    <v-flex xs12>
      <h2>Apostas Em Andamento, por Jogo</h2>
      <v-data-table
          :headers="headers3"
          :items="openEvents"
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ geteventName(props.item) }}</td>
            <td>{{ geteventType(props.item) }}</td>
            <td>{{ geteventOdds(props.item) }}</td>
            <td v-html="geteventTotalHome(props.item)"></td>
            <td v-html="geteventTotalDraw(props.item)"></td>
            <td v-html="geteventTotalAway(props.item)"></td>
          </template>
        </v-data-table>

      <hr>

      <v-flex xs12>
        <h2>Apostas Em Andamento</h2>
        <br>
        <v-data-table
          :headers="headers2"
          :items="openBets"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ findBet("event_id",props.item.event_id)["eventName"] }}</td>
            <td>{{ findBetName(props.item.betType) }}</td>
            <td>{{ props.item.odds }}</td>
            <td>{{ props.item.positionName }}</td>
            <td>{{ "R$" + parseFloat(props.item.betValue).toFixed(2) }}</td>
            <td>{{ "R$" + (parseFloat(props.item.betValue) * parseFloat(props.item.odds) ).toFixed(2)  }}</td>
          </template>
        </v-data-table>
      </v-flex>      

      <h2>Apostas Encerradas</h2>
        <br>
        <v-data-table
                  :headers="headers1"
                  :items="closedBets"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ findBet("event_id",props.item.event_id)["eventName"] }}</td>
                    <td>{{ findBetName(props.item.betType) }}</td>
                    <td>{{ props.item.odds }}</td>
                    <td>{{ props.item.positionName }}</td>
                    <td>{{ "R$" + parseFloat(props.item.betValue).toFixed(2) }}</td>
                    <td>{{ "R$" + parseFloat(props.item.resultValue).toFixed(2)  }}</td>
                  </template>
                </v-data-table>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import {listBets} from '../graphql/queries'
  import {onCreateBet,onUpdateBet} from '../graphql/subscriptions'
  import API, { graphqlOperation } from "@aws-amplify/api";

  export default {
    mounted: function () {
      var that = this
      const filterClosedBets = { status_id: { ne: "0"}}
      const filterOpenBets = { status_id: { eq: "0"}}
      
      API.graphql(graphqlOperation(listBets,{limit: 10000,filter: filterOpenBets})).then(function(result) {
          that.openBets = result.data.listBets.items
      });

      API.graphql(graphqlOperation(listBets,{limit: 10000,filter: filterClosedBets})).then(function(result) {
          that.closedBets = result.data.listBets.items
      });

      const subscription = API.graphql(
        graphqlOperation(onCreateBet)
      ).subscribe({
        next: (eventData) => this.handleNewBet(eventData)
      });

      const subscription2 = API.graphql(
        graphqlOperation(onUpdateBet)
      ).subscribe({
        next: (eventData) => this.handleBetUpdate(eventData)
      });      
    },
    computed: {
      listClosedBetsQuery(){
        // const filter = { status_id: { ne: "0"}}
        // return this.$Amplify.graphqlOperation(listBets,{limit: 10000,filter: filter});//o certo é paginar :D
      },
      listOpenBetsQuery(){
        // const filter = { status_id: { eq: "0"}}
        // return this.$Amplify.graphqlOperation(listBets,{limit: 10000,filter: filter});//o certo é paginar :D
      },      
      createBetSubscription() {
        // return this.$Amplify.graphqlOperation(onCreateBet);
      },
      openEvents(){
        var list = this.openBets;
        var keyGetter = bet => bet.event_id+"|"+bet.betType+"|"+bet.handicap;
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return Array.from( map.keys() );
      }
    },
    data () {
      return {
        headers1: [
          { text: 'Evento', value: 'evento' },
          { text: 'Tipo de Aposta', value: 'betType' },
          { text: 'Odds', value: 'odds' },
          { text: 'Posicao', value: 'posicao' },
          { text: 'Valor', value: 'valor' },
          { text: 'Resultado', value: 'resultado' },
        ],
        headers2: [
          { text: 'Evento', value: 'evento' },
          { text: 'Tipo de Aposta', value: 'betType' },
          { text: 'Odds', value: 'odds' },
          { text: 'Posicao', value: 'posicao' },
          { text: 'Valor', value: 'valor' },
          { text: 'Payout', value: 'payout' },
        ],
        headers3: [
          { text: 'Evento', value: 'event' },
          { text: 'Tipo Aposta', value: 'betType' },
          { text: 'Handicap', value: 'odds' },
          { text: 'Total Home/Over', value: 'home' },
          { text: 'Total Draw', value: 'draw' },
          { text: 'Total Away/Under', value: 'away' },
        ],        
        pagination: {
          rowsPerPage: 25
        },
        openBets:[],
        closedBets:[]
      }
    },
    methods: {
      handleNewBet(incoming){
        var newBet = incoming.value.data.onCreateBet
        if(newBet["status_id"] == "0"){
          var exists = false
          for(var i = 0;i<this.openBets.length;i++){
            if(this.openBets[i]["id"] == newBet["id"]){
              exists = true
            }
          }
          if(!exists){
            this.openBets.push(newBet)  
          }
          
        }
        else{
          var exists = false
          for(var i = 0;i<this.closedBets.length;i++){
            if(this.closedBets[i]["id"] == newBet["id"]){
              exists = true
            }
          }
          if(!exists){
            this.closedBets.push(newBet)  
          }
        }
      },
      handleBetUpdate(incoming){
        var updatedBet = incoming.value.data.onUpdateBet
        if(updatedBet["status_id"] != "0"){
          var exists = false
          var index = -1

          for(var i = 0;i<this.openBets.length;i++){
            if(this.openBets[i]["id"] == updatedBet["id"]){
              exists = true
              index = i
            }
          }
          if(exists){
            this.openBets.splice(index,1)
            this.closedBets.push(updatedBet)  
          }
          
        }
      },
      findBet(field,value){
        for(var i=0;i<this.openBets.length;i++)
        {
          if(this.openBets[i][field] == value)
          {
            return this.openBets[i]
          }
        }
        for(var i=0;i<this.closedBets.length;i++)
        {
          if(this.closedBets[i][field] == value)
          {
            return this.closedBets[i]
          }
        }      
        return false  
      },
      geteventName(data){
        var event_id = data.split("|")[0]
        var bet = this.findBet("event_id",event_id)
        return bet["eventName"]
      },
      findBetName(key){
        var odds = {
            '1_1' : '1X2, Full Time Result',
            '1_2' : 'Asian Handicap',
            '1_3' : 'O/U, Goal Line',
            '1_4' : 'Asian Corners',
            '1_5' : '1st Half Asian Handicap',
            '1_6' : '1st Half Goal Line',
            '1_7' : '1st Half Asian Corners',
            '1_8' : 'Half Time Result',    
            '*_1' : 'Match Winner 2-Way',
            '*_2' : 'Asian Handicap',
            '*_3' : 'Over/Under',
            '3_4' : 'Draw No Bet',
            '18_1' : 'Money Line',
            '18_2' : 'Spread',
            '18_3' : 'Total Points',
            '18_4' : 'Money Line (Half)',
            '18_5' : 'Spread (Half)',
            '18_6' : 'Total Points (Half)',
            '18_7' : 'Quarter - Winner (2-Way)',
            '18_8' : 'Quarter - Handicap',
            '18_9' : 'Quarter - Total (2-Way)'
        }
        return odds[key]
      },
      geteventType(data){
        return this.findBetName(data.split("|")[1])
      },
      geteventOdds(data){
        return data.split("|")[2]
      },
      geteventTotalHome(data){
        var result = 0
        var payout = 0
        for(var i=0;i<this.openBets.length;i++)
        {
          if(this.openBets[i]["event_id"] == data.split("|")[0] && 
             this.openBets[i]["betType"] == data.split("|")[1] && 
             this.openBets[i]["handicap"] == data.split("|")[2] && 
             this.openBets[i]["betPosition"] == "b1"){
            result += parseFloat(this.openBets[i]["betValue"])
            payout += parseFloat(this.openBets[i]["betValue"]) * parseFloat(this.openBets[i]["odds"])
          }

        }
        return "Apostas: R$"+ result.toFixed(2) + "<br>Payout: R$" + payout.toFixed(2)
      },
      geteventTotalAway(data){
        var result = 0
        var payout = 0
        for(var i=0;i<this.openBets.length;i++)
        {
          var betPosition
          if(["1_1","1_8"].includes(this.openBets[i]["betType"])){
            betPosition = "b3"
          }
          else{
            betPosition = "b2"
          }
          if(this.openBets[i]["event_id"] == data.split("|")[0] && 
             this.openBets[i]["betType"] == data.split("|")[1] && 
             this.openBets[i]["handicap"] == data.split("|")[2] && 
             this.openBets[i]["betPosition"] == betPosition)
            {
                result += parseFloat(this.openBets[i]["betValue"])
                payout += parseFloat(this.openBets[i]["betValue"]) * parseFloat(this.openBets[i]["odds"])
            }

        }
        return "Apostas: R$"+ result.toFixed(2) + "<br>Payout: R$" + payout.toFixed(2)
      },
      geteventTotalDraw(data){
        var result = 0
        var payout = 0
        for(var i=0;i<this.openBets.length;i++)
        {
          if(this.openBets[i]["event_id"] == data.split("|")[0] && 
             this.openBets[i]["betType"] == data.split("|")[1] && 
             this.openBets[i]["handicap"] == data.split("|")[2] && 
             this.openBets[i]["betPosition"] == "b2")
          {
                if(["1_1","1_8"].includes(this.openBets[i]["betType"])){
                  result += parseFloat(this.openBets[i]["betValue"])  
                  payout += parseFloat(this.openBets[i]["betValue"]) * parseFloat(this.openBets[i]["odds"])
                }
          }

        }
        return "Apostas: R$"+ result.toFixed(2) + "<br>Payout: R$" + payout.toFixed(2)
      }                                    
    }
  }
</script>